import React from "react";
import { Link } from "react-router-dom";
import WhyChooseImg1 from "../../assets/images/resources/why-choose-one-img-1.jpg";
import imgSafeLift from "../../assets/images/icon/safeLift.png";
const WhyChoose = () => {
  return (
    <>
      {/* Why Choose One Start */}
      <section className="why-choose-one">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <div className="why-choose-one__left">
                <div className="section-title text-left">
                  <div className="section-title__tagline-box">
                    <span className="section-title__tagline">
                      Why Choose us
                    </span>
                  </div>
                  <h2 className="section-title__title">
                    Delivering excellence with every rise – Arch Elevators
                  </h2>
                </div>
                <p className="why-choose-one__text">
                  At <strong>Arch Elevators</strong>, we don’t just move people
                  — we elevate lives through cutting-edge vertical transport
                  solutions. With decades of expertise and a passion for
                  precision, we design and manufacture elevators that combine
                  performance, safety, and style. From luxury residences to
                  large-scale infrastructure projects, our lifts are trusted
                  across industries for their reliability, customization, and
                  long-lasting value.
                </p>
                <div className="why-choose-one__btn-box">
                  <Link to="/about" className="thm-btn why-choose-one__btn">
                    Read more
                    <span />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="why-choose-one__right">
                <div
                  className="why-choose-one__img wow slideInRight"
                  data-wow-delay="100ms"
                  data-wow-duration="2500ms"
                >
                  <img src={WhyChooseImg1} alt="Why Choose Us" />
                  {/* <div className="why-choose-one__delivery-box">
                    <div className="icon">
                      <span className="icon-airplane">
                        <img
                          src={imgSafeLift}
                          alt="SafeLift"
                          style={{ height: "50px", width: "50px" }}
                        />
                      </span>
                    </div>
                    <p>
                      SAFETY, STYLE,
                      <br /> HEIGHT
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Why Choose One End */}
    </>
  );
};

export default WhyChoose;
